<template>
  <form
    ref="form"
    class="form form--availability form--custom-empty-legs js-customEmptyLegsForm"
    :class="[{'loading' : loading}]"
    @submit.prevent="submitHandler"
  >
    <div class="form__labelGroup form__labelGroup--aircraft-mode">
      <div class="form__radioGroup">
        <label class="form__label form__label--radio">
          <input
            class="form__radio"
            type="radio"
            v-model="aircraftMode"
            value="new-aircraft"
          />
          <span class="form__radio-box">New aircraft</span>
        </label>
        <label class="form__label form__label--radio">
          <input
            class="form__radio"
            type="radio"
            v-model="aircraftMode"
            value="select-aircraft"
          />
          <span class="form__radio-box">Select aircraft</span>
        </label>
      </div>

      <label
        v-if="aircraftMode === 'select-aircraft'"
        class="form__label form__label--select"
        style="margin-bottom: 15px;"
      >
        <div class="form__caption">Aircraft number</div>
        <div class="form__field-wrapper">
          <div class="selectContainer js-select-custom-empty-legs"></div>
          <a-select
            class="form__select"
            :getPopupContainer="selectContainer"
            :value="selectedAircraftTailNumber"
            :disabled="loading"
            placeholder="Choose from list"
            style="width:100%;"
            @change="selectAircraft"
          >
            <a-select-option
              v-for="(item, index) of fleet"
              :key="index"
              :value="item.tailNumber"
            >
              {{ item.tailNumber + ' ' + (item.aircraftModelId === '6314c38d-0f05-41bc-9004-4f338aac024d' ? item.typeName : item.modelName) }}
            </a-select-option>
          </a-select>
          <span
            v-if="!selectedAircraft && isNotReadyToSubmit == true"
            class="form__field-invalid form__field-invalid--right-side"
            style="color: #000"
          >
            This field is required
          </span>
        </div>
      </label>
    </div>

    <div class="form__labelGroup form__labelGroup--photos customEmptyLegsPhotos fleetDashboard">
      <div class="fleetDashboard__photos">
        <div class="fleetDashboard__photos-header">
          <div class="fleetDashboard__photos-title">Upload photos</div>
        </div>
        <div class="fleetDashboard__photos-left">
          <div class="fleetDashboard__photos-slider js-customEmptyLegsPhotos">
            <div class="swiper-container custom-empty-legs-photos-swiper" ref="swiperTop">
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide"
                  v-for="order in photoSlotCount"
                  :key="order"
                  :data-id="order"
                >
                  <span
                    class="fleetDashboard__photos-slider-item"
                    :style="photoByOrder(order) ? {backgroundImage: `url(${photoByOrder(order).url})`} : ''"
                  >
                    <label
                      class="form__file form__file--photos js-file-img"
                      :class="{'preview' : photoByOrder(order)}"
                    >
                      <input
                        :ref="`photoInput${order}`"
                        type="file"
                        name="photo"
                        accept="image/*"
                        :disabled="loading"
                        @change="changePhoto($event, order)"
                      />
                      <div
                        class="form__file-remove js-file-remove"
                        :class="{'hide' : !photoByOrder(order)}"
                        title="Delete photo"
                        @click.prevent="removePhoto(order)"
                      >
                        <SvgIcon name="rubbish-bin"/>
                      </div>
                      <div v-if="!photoByOrder(order)" class="form__file-icon">
                        <SvgIcon name="photo-camera"/>
                      </div>
                      <div class="form__file-caption js-file-name">
                        {{ photoByOrder(order) ? photoByOrder(order).name : 'Upload photo' }}
                      </div>
                    </label>
                  </span>
                </div>
              </div>
            </div>
            <div class="swiper-pagination custom-empty-legs-photos-pagination"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="form__left">
      <div class="form__labelGroup">
        <div class="form__radioGroup">
          <label class="form__label form__label--radio">
            <input
              class="form__radio"
              type="radio"
              v-model="spacesOnly"
              :value="false"
            />
            <span class="form__radio-box">Empty leg</span>
          </label>
          <label class="form__label form__label--radio">
            <input
              class="form__radio"
              type="radio"
              v-model="spacesOnly"
              :value="true"
            />
            <span class="form__radio-box">Spaces only</span>
          </label>
        </div>
      </div>

      <div class="form__labelGroup form__labelGroup--model-class">
        <label class="form__label form__label--text">
          <div class="form__caption">
            <span class="icon"><SvgIcon name="airplane"/></span>
            <span class="text">Model / class:</span>
          </div>
          <div class="form__field-wrapper">
            <input
              class="form__field js-typeahead"
              type="text"
              v-model="aircraftModelOrTypeName"
              placeholder="Enter model"
              autocomplete="off"
              :disabled="loading"
              @input="searchAircraftModels"
              @focus="showModelTypeahead"
              @blur="hideTypeahead"
            />
            <div
              class="typeahead-menu typeahead-empty"
              :class="{'typeahead-open' : typeaheadMenu === 'modelClass'}"
            >
              <div class="typeahead-dataset typeahead-dataset-types">
                <div
                  class="typeahead-suggestion typeahead-selectable"
                  v-for="item in aircraftModelItems"
                  :key="(item.typeShortName || item.typeName) ? `model-${item.id}` : `type-${item.id}`"
                  @click="selectAircraftModel(item)"
                >{{ item.name }}</div>
              </div>
            </div>
            <span
              v-if="!aircraftModelOrTypeName && isNotReadyToSubmit == true"
              class="form__field-invalid form__field-invalid--right-side"
              style="color: #000"
            >
              This field is required
            </span>
          </div>
        </label>
        <label class="form__label form__label--text">
          <div class="form__caption">
            <span class="icon"><SvgIcon name="airplane"/></span>
            <span class="text">Display Model / class:</span>
          </div>
          <div class="form__field-wrapper">
            <input
              class="form__field"
              type="text"
              v-model="displayModelOrTypeName"
              autocomplete="off"
              :disabled="loading"
            />
          </div>
        </label>
      </div>

      <div class="form__labelGroup form__labelGroup--locations">
        <label class="form__label form__label--text form__label--location-main">
          <div class="form__caption">
            <span class="icon"><SvgIcon name="departures"/></span>
            <span class="text">Departure airport:</span>
          </div>
          <div class="form__field-wrapper">
            <input
              class="form__field js-typeahead"
              type="text"
              v-model="departure"
              placeholder="Enter here"
              autocomplete="off"
              :disabled="loading"
              @input="searchLocations('departure', departure)"
            />
            <div
              class="typeahead-menu typeahead-empty"
              :class="{'typeahead-open' : departureItems.length > 0}"
            >
              <div class="typeahead-dataset typeahead-dataset-types">
                <div
                  class="typeahead-suggestion typeahead-selectable"
                  v-for="item in departureItems"
                  :key="item.id"
                  @click="selectPotentialLocation('departure', item)"
                >{{ item.name }}</div>
              </div>
            </div>
            <span
              v-if="!selectedDeparture && isNotReadyToSubmit == true"
              class="form__field-invalid form__field-invalid--right-side"
              style="color: #000"
            >
              This field is required
            </span>
          </div>
        </label>
        <label class="form__label form__label--text form__label--display-name">
          <div class="form__caption">
            <span class="icon"><SvgIcon name="departures"/></span>
            <span class="text">Display Departure:</span>
          </div>
          <div class="form__field-wrapper">
            <input
              class="form__field"
              type="text"
              v-model="displayDeparture"
              autocomplete="off"
              :disabled="loading"
            />
          </div>
        </label>
        <label class="form__label form__label--text form__label--display">
          <div class="form__caption">
            <span class="icon"><SvgIcon name="departures"/></span>
            <span class="text">Code:</span>
          </div>
          <div class="form__field-wrapper">
            <input
              class="form__field"
              type="text"
              v-model="displayDepartureCode"
              autocomplete="off"
              :disabled="loading"
            />
          </div>
        </label>
        <label class="form__label form__label--text form__label--location-main">
          <div class="form__caption">
            <span class="icon"><SvgIcon name="arrival"/></span>
            <span class="text">Landing airport:</span>
          </div>
          <div class="form__field-wrapper">
            <input
              class="form__field js-typeahead"
              type="text"
              v-model="landing"
              placeholder="Enter here"
              autocomplete="off"
              :disabled="loading"
              @input="searchLocations('landing', landing)"
            />
            <div
              class="typeahead-menu typeahead-empty"
              :class="{'typeahead-open' : landingItems.length > 0}"
            >
              <div class="typeahead-dataset typeahead-dataset-types">
                <div
                  class="typeahead-suggestion typeahead-selectable"
                  v-for="item in landingItems"
                  :key="item.id"
                  @click="selectPotentialLocation('landing', item)"
                >{{ item.name }}</div>
              </div>
            </div>
            <span
              v-if="!selectedLanding && isNotReadyToSubmit == true"
              class="form__field-invalid form__field-invalid--right-side"
              style="color: #000"
            >
              This field is required
            </span>
          </div>
        </label>
        <label class="form__label form__label--text form__label--display-name">
          <div class="form__caption">
            <span class="icon"><SvgIcon name="arrival"/></span>
            <span class="text">Display Landing:</span>
          </div>
          <div class="form__field-wrapper">
            <input
              class="form__field"
              type="text"
              v-model="displayArrival"
              autocomplete="off"
              :disabled="loading"
            />
          </div>
        </label>
        <label class="form__label form__label--text form__label--display">
          <div class="form__caption">
            <span class="icon"><SvgIcon name="arrival"/></span>
            <span class="text">Code:</span>
          </div>
          <div class="form__field-wrapper">
            <input
              class="form__field"
              type="text"
              v-model="displayArrivalCode"
              autocomplete="off"
              :disabled="loading"
            />
          </div>
        </label>
      </div>

      <div
        class="form__labelGroup form__labelGroup--date flightAvailability__form-date"
      >
        <div class="form__header">
          <div class="form__title">Available Dates:</div>
          <div
            class="form__label form__label--date js-list-dates"
          >
            <div class="form__caption">
              <span class="icon"><SvgIcon name="calendar"/></span>
              <span class="text">From-To:</span>
            </div>
            <div class="form__field-list form__field-list--from-to">
              <div
                class="form__field-wrapper js-wrapper-dates"
              >
                <label
                  class="js-item-dates form__label--date-time"
                  :class="{'form__label--date-time-selected': dateRange && dateRange.length > 0}"
                >
                  <a-range-picker
                    format="MM/DD/YYYY"
                    :placeholder="['click to change', '']"
                    :separator="dateRange && dateRange.length > 0 ? ' - ' : ''"
                    v-model="dateRange"
                    :getCalendarContainer="getPickerContainer"
                    :disabled="loading || isEdit"
                  />
                  <span
                    v-if="(!dateRange || dateRange.length < 2) && isNotReadyToSubmit == true"
                    class="form__field-invalid form__field-invalid--right-side"
                    style="color: #000"
                  >
                    This field is required
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="form__optionalFields js-accordion-item"
        :class="{'open': optionalFieldsOpen}"
      >
        <div class="form__optionalFields-header js-acc-title" @click="toggleOptionalFields">
          <span class="form__optionalFields-title">Optional fields</span>
          <span class="form__optionalFields-icon">
            <span class="form__optionalFields-icon-minus"><SvgIcon name="minus"/></span>
            <span class="form__optionalFields-icon-plus"><SvgIcon name="add"/></span>
          </span>
        </div>
        <div ref="optionalFieldsContent" class="form__optionalFields-content js-acc-content">
          <div class="form__optionalFields-grid">
            <label class="form__label form__label--number">
              <div class="form__caption">Max pax:</div>
              <div class="form__field-wrapper">
                <input
                  class="form__field js-numberOnly"
                  type="number"
                  v-model="maxPax"
                  placeholder="Enter number here"
                  autocomplete="off"
                  :disabled="loading"
                />
              </div>
            </label>
            <label class="form__label form__label--number">
              <div class="form__caption">Spaces:</div>
              <div class="form__field-wrapper">
                <input
                  class="form__field js-numberOnly"
                  type="number"
                  v-model="spaces"
                  placeholder="Enter number here"
                  autocomplete="off"
                  :disabled="loading"
                />
              </div>
            </label>
            <label class="form__label form__label--text">
              <div class="form__caption">Argus:</div>
              <div class="form__field-wrapper">
                <input
                  class="form__field"
                  type="text"
                  v-model="argusSafetyRating"
                  placeholder="Enter here"
                  autocomplete="off"
                  :disabled="loading"
                />
              </div>
            </label>
            <label class="form__label form__label--text">
              <div class="form__caption">Wyvern:</div>
              <div class="form__field-wrapper">
                <input
                  class="form__field"
                  type="text"
                  v-model="wyvernSafetyRating"
                  placeholder="Enter here"
                  autocomplete="off"
                  :disabled="loading"
                />
              </div>
            </label>
            <label class="form__label form__label--select form__label--wifi">
              <div class="form__caption">Wi-Fi:</div>
              <div class="form__field-wrapper">
                <div class="selectContainer js-select-custom-empty-legs-wifi"></div>
                <a-select
                  class="form__select"
                  :getPopupContainer="wifiSelectContainer"
                  :value="wiFiTypeName"
                  :disabled="loading"
                  placeholder="Choose from list"
                  style="width:100%;"
                  @change="selectWiFiType"
                >
                  <a-select-option
                    v-for="(item, index) of wiFiTypes"
                    :key="index"
                    :value="item.name"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </div>
            </label>
          </div>
        </div>
      </div>

      <label v-if="spacesOnly" class="form__label form__label--number">
        <div class="form__caption">Spaces available:</div>
        <div class="form__field-wrapper">
          <input
            class="form__field js-numberOnly"
            type="number"
            v-model="spacesAvailable"
            placeholder="Enter number here"
            autocomplete="off"
            :disabled="loading"
          />
        </div>
      </label>

      <div class="form__labelGroup form__labelGroup--price">
        <div class="form__title">Price:</div>
        <label class="form__label form__label--price price">
          <div class="form__field-wrapper">
            <input
              class="form__field"
              type="number"
              v-model="price"
              placeholder="Enter cost here in $"
              autocomplete="off"
              :disabled="loading"
            />
            <span
              v-if="!price && isNotReadyToSubmit == true"
              class="form__field-invalid form__field-invalid--right-side"
              style="color: #000"
            >
              This field is required
            </span>
          </div>
        </label>
      </div>

      <label class="form__label form__label--number" style="margin-top: 30px;">
        <div class="form__caption">Departure Re-routing radius:</div>
        <div class="form__field-wrapper">
          <input
            class="form__field js-numberOnly"
            type="number"
            v-model.number="departureReroutingRadius"
            placeholder="Number of nautical miles"
            autocomplete="off"
            :disabled="loading"
          />
        </div>
      </label>
      <label class="form__label form__label--number">
        <div class="form__caption">Arrival Re-routing radius:</div>
        <div class="form__field-wrapper">
          <input
            class="form__field js-numberOnly"
            type="number"
            v-model.number="arrivalReroutingRadius"
            placeholder="Number of nautical miles"
            autocomplete="off"
            :disabled="loading"
          />
        </div>
      </label>

      <span
        v-if="isNotReadyToSubmit == true"
        class="form__field-invalid"
      >
        Please fill out all fields.
      </span>

      <div class="form__labelGroup form__labelGroup--send-route-alerts">
        <div class="form__caption">Send Route Alerts</div>
        <div class="form__radioGroup">
          <label
            class="form__label form__label--radio"
            :class="{'checked': sendRouteAlert === true}"
          >
            <input
              class="form__radio"
              type="radio"
              v-model="sendRouteAlert"
              :value="true"
              :disabled="loading"
            />
            <span class="form__radio-box form__radio-box--yes">Yes</span>
          </label>
          <label
            class="form__label form__label--radio"
            :class="{'checked': sendRouteAlert === false}"
          >
            <input
              class="form__radio"
              type="radio"
              v-model="sendRouteAlert"
              :value="false"
              :disabled="loading"
            />
            <span class="form__radio-box form__radio-box--no">No</span>
          </label>
        </div>
      </div>

      <div class="form__label form__label--button">
        <button class="form__button" :disabled="loading">
          <Spinner/>
          <span class="text">Save</span>
        </button>
      </div>
    </div>
  </form>
</template>

<script>
  import moment from 'moment'
  import { aircraftsAPI } from '@/api/aircrafts'
  import { locationsAPI } from '@/api/locations'
  import SvgIcon from '@/components/common/SvgIcon/SvgIcon'
  import Spinner from '@/components/common/Spinner/Spinner'
  import Swiper, { Pagination } from 'swiper'
  import '@/components/common/SelectCommon/SelectCommon'
  import '@/components/dashboard/FlightUploadsForm/FlightUploadsForm.styl'
  import '@/views/dashboard/common/DetailAircraft/DetailAircraft.styl'
  import './CustomEmptyLegsAndSpacesForm.styl'

  Swiper.use([Pagination])

  export default {
    name: 'CustomEmptyLegsAndSpacesForm',
    data: () => ({
      swiper: null,
      loading: false,
      aircraftMode: 'new-aircraft',
      selectedAircraft: null,
      selectedAircraftTailNumber: undefined,
      aircraftModelOrTypeName: '',
      displayModelOrTypeName: '',
      aircraftModelOrTypeId: null,
      selectedAircraftIsType: false,
      departure: '',
      displayDeparture: '',
      displayDepartureCode: '',
      landing: '',
      displayArrival: '',
      displayArrivalCode: '',
      selectedDeparture: null,
      selectedLanding: null,
      dateRange: [],
      price: '',
      departureReroutingRadius: null,
      arrivalReroutingRadius: null,
      spacesOnly: false,
      sendRouteAlert: true,
      spacesAvailable: null,
      maxPax: null,
      spaces: null,
      argusSafetyRating: '',
      wyvernSafetyRating: '',
      wiFiTypeId: '67cdd833-48c1-4499-a5fa-712513ca3f33',
      wiFiTypeName: undefined,
      photos: [],
      removedPhotoIds: [],
      photoSlotCount: 7,
      aircraftModelItems: [],
      departureItems: [],
      landingItems: [],
      typeaheadMenu: null,
      timeout: null,
      isNotReadyToSubmit: false,
      emptyLegId: null,
      optionalFieldsOpen: false,
    }),
    computed: {
      fleet () {
        return this.$store.state.fleet.list
      },
      wiFiTypes () {
        return this.$store.state.fleet.wiFiTypes
      },
      isEdit () {
        const last = this.$route.path.split('/').pop()
        return last !== 'new' && last !== 'custom-empty-legs-and-spaces'
      },
      emptyLegRouteId () {
        return this.isEdit ? this.$route.path.split('/').pop() : null
      },
    },
    async created () {
      await Promise.all([
        this.$store.dispatch('getAircrafts'),
        this.$store.dispatch('getWiFiTypes'),
      ])

      if (this.isEdit) {
        await this.loadEntity()
      }
    },
    watch: {
      aircraftMode (value) {
        if (value === 'new-aircraft') {
          this.selectedAircraft = null
          this.selectedAircraftTailNumber = undefined
          this.spaces = null
          this.maxPax = null
          this.argusSafetyRating = ''
          this.wyvernSafetyRating = ''
          this.wiFiTypeId = '67cdd833-48c1-4499-a5fa-712513ca3f33'
          this.wiFiTypeName = undefined
          this.photos = []
          this.removedPhotoIds = []
        }
      },
      spacesOnly (value) {
        if (!value) {
          this.spacesAvailable = null
        }
      },
    },
    mounted () {
      this.$root.fields.changeRadio('.form__radio')
      this.initPhotosSwiper()
    },
    destroyed () {
      if (this.swiper) {
        this.swiper.destroy()
      }
    },
    methods: {
      initPhotosSwiper () {
        this.swiper = new Swiper('.custom-empty-legs-photos-swiper', {
          slidesPerView: 1,
          pagination: {
            el: '.custom-empty-legs-photos-pagination',
            type: 'bullets',
            clickable: true,
          },
        })
      },
      photoByOrder (order) {
        return this.photos.find(photo => photo.order === order)
      },
      isReadyToSubmit () {
        const isAircraftSelected = this.aircraftMode !== 'select-aircraft' || this.selectedAircraft
        const isDateRangeSelected = this.dateRange && this.dateRange.length === 2
        const isSpacesReady = !this.spacesOnly || this.spacesAvailable

        return this.aircraftModelOrTypeName &&
          isAircraftSelected &&
          this.selectedDeparture &&
          this.selectedLanding &&
          isDateRangeSelected &&
          isSpacesReady &&
          this.price !== ''
      },

      async searchAircraftModels () {
        if (this.timeout != null) {
          clearTimeout(this.timeout)
        }

        this.timeout = setTimeout(async () => {
          this.timeout = null

          this.aircraftModelOrTypeId = null;

          if (!this.aircraftModelOrTypeName) {
            this.aircraftModelItems = []
            this.typeaheadMenu = null
            return
          }

          try {
            const [{ data: models }, { data: types }] = await Promise.all([
              aircraftsAPI.searchAircraftModelsWithoutType({ query: this.aircraftModelOrTypeName }),
              aircraftsAPI.searchAircraftTypes({ query: this.aircraftModelOrTypeName }),
            ])
            this.aircraftModelItems = [...types, ...models]
            this.showModelTypeahead()
          } catch (e) {
            this.aircraftModelItems = []
            this.typeaheadMenu = null
            console.log(e)
          }
        }, 500)
      },
      showModelTypeahead () {
        this.typeaheadMenu = this.aircraftModelItems.length ? 'modelClass' : null
      },
      hideTypeahead () {
        setTimeout(() => {
          this.typeaheadMenu = null
        }, 200)
      },
      selectAircraftModel (item) {
        const typeName = item.typeShortName || item.typeName
        this.aircraftModelOrTypeName = item.name
        this.displayModelOrTypeName = typeName ? `${item.name} (${typeName})` : item.name
        this.aircraftModelOrTypeId = item.id
        this.selectedAircraftIsType = !typeName
        this.aircraftModelItems = []
        this.typeaheadMenu = null
      },
      applyFleetAircraftModelFields () {
        if (!this.selectedAircraft) return

        const modelName = this.selectedAircraft.modelName
        const typeName = this.selectedAircraft.typeName
        const isTypeOnlyModel = this.selectedAircraft.aircraftModelId === '6314c38d-0f05-41bc-9004-4f338aac024d' // N-A

        if (isTypeOnlyModel) {
          this.displayModelOrTypeName = typeName
          this.aircraftModelOrTypeName = typeName
          this.aircraftModelOrTypeId = this.selectedAircraft.aircraftTypeId
          this.selectedAircraftIsType = true
        } else {
          this.displayModelOrTypeName = typeName ? `${modelName} (${typeName})` : modelName
          this.aircraftModelOrTypeName = modelName
          this.aircraftModelOrTypeId = this.selectedAircraft.aircraftModelId
          this.selectedAircraftIsType = false
        }
      },
      async selectAircraft (tailNumber) {
        this.selectedAircraft = this.fleet.find(item => item.tailNumber === tailNumber) || null

        if (!this.selectedAircraft) {
          return
        }

        this.aircraftMode = 'select-aircraft'

        this.selectedAircraftTailNumber = tailNumber

        this.applyFleetAircraftModelFields()

        this.loadAircraftOptionalFields(this.selectedAircraft)
        this.photos = (this.selectedAircraft.images || []).map((image, index) => ({
          ...image,
          url: image.url || image.fileName,
          order: image.order != null ? image.order : index + 1,
        }))
        this.removedPhotoIds = []

        this.$nextTick(() => {
          if (this.swiper) {
            this.swiper.update()
          }
        })
      },
      async searchLocations (locationType, query) {
        if (this.timeout != null) {
          clearTimeout(this.timeout)
        }

        this.timeout = setTimeout(async () => {
          this.timeout = null

          try {
            const { data } = await locationsAPI.searchLocations({ query })

            if (locationType === 'departure') {
              this.departureItems = data
            } else {
              this.landingItems = data
            }
          } catch (e) {
            console.log(e)
          }
        }, 600)
      },
      selectPotentialLocation (locationType, item) {
        if (locationType === 'departure') {
          this.selectedDeparture = item
          this.departure = item.name
          this.departureItems = []
        } else {
          this.selectedLanding = item
          this.landing = item.name
          this.landingItems = []
        }
      },
      getPickerContainer () {
        return this.$refs.form
      },
      selectContainer () {
        return this.$refs.form.querySelector('.js-select-custom-empty-legs')
      },
      wifiSelectContainer () {
        return this.$refs.form
      },
      selectWiFiType (name) {
        const wiFiType = this.wiFiTypes.find(item => item.name === name)

        this.wiFiTypeName = name
        this.wiFiTypeId = wiFiType?.id
      },
      loadAircraftOptionalFields (aircraft) {
        this.maxPax = aircraft.maxPassengers || null
        this.spaces = aircraft.spaces || null
        this.argusSafetyRating = aircraft.argusSafetyRating
        this.wyvernSafetyRating = aircraft.wyvernSafetyRating
        this.wiFiTypeId = aircraft.wiFiType?.id || null
        this.wiFiTypeName = aircraft.wiFiType?.name || undefined
      },
      syncRadioCheckedState () {
        this.$nextTick(() => {
          if (!this.$refs.form) return

          this.$refs.form.querySelectorAll('input[type="radio"]').forEach((elem) => {
            const label = elem.closest('.form__label--radio')

            if (!label) return

            if (elem.checked) {
              label.classList.add('checked')
            } else {
              label.classList.remove('checked')
            }
          })
        })
      },
      toggleOptionalFields (event) {
        const item = event.currentTarget.closest('.js-accordion-item').querySelector('.js-acc-content')
        this.optionalFieldsOpen = this.$root.animations.slideToggle(item)
      },
      trackRemovedPhoto (photo) {
        if (photo?.id && !this.removedPhotoIds.includes(photo.id)) {
          this.removedPhotoIds.push(photo.id)
        }
      },
      changePhoto (event, order) {
        const file = event.target.files[0]

        if (!file) return

        this.trackRemovedPhoto(this.photoByOrder(order))

        const fr = new FileReader()
        fr.addEventListener('load', () => {
          this.photos = this.photos.filter(photo => photo.order !== order)
          this.photos.push({
            file,
            url: fr.result,
            name: file.name,
            order,
          })
        }, false)
        fr.readAsDataURL(file)
      },
      removePhoto (order) {
        this.trackRemovedPhoto(this.photoByOrder(order))

        this.photos = this.photos.filter(photo => photo.order !== order)

        const input = this.$refs[`photoInput${order}`]

        if (input && input[0]) {
          input[0].value = ''
        }
      },
      async removeEditedPhotos () {
        await Promise.all(
          this.removedPhotoIds.map(async (imageId) => {
            const result = await aircraftsAPI.removeImage(imageId)

            if (!result.data.isSuccessfull) {
              throw new Error(result.data.message || 'Can not remove image')
            }
          }),
        )
      },
      async loadEntity () {
        this.loading = true

        try {
          const { data: emptyLeg } = await aircraftsAPI.getEmptyLegs(this.emptyLegRouteId)

          this.emptyLegId = emptyLeg.id

          const departureDate = moment(new Date(emptyLeg.departureDate))
          this.dateRange = [departureDate, departureDate]

          this.departure = emptyLeg.departure
          this.selectedDeparture = { id: emptyLeg.departureId }
          this.landing = emptyLeg.arrival
          this.selectedLanding = { id: emptyLeg.arrivalId }
          this.displayDeparture = emptyLeg.displayDeparture || ''
          this.displayArrival = emptyLeg.displayArrival || ''
          this.displayDepartureCode = emptyLeg.displayDepartureCode || ''
          this.displayArrivalCode = emptyLeg.displayArrivalCode || ''
          this.departureReroutingRadius = emptyLeg.departureReroutingRadius != null
            ? Number(emptyLeg.departureReroutingRadius)
            : null
          this.arrivalReroutingRadius = emptyLeg.arrivalReroutingRadius != null
            ? Number(emptyLeg.arrivalReroutingRadius)
            : null

          this.spacesOnly = emptyLeg.spacesAvailable != null
          this.spacesAvailable = emptyLeg.spacesAvailable != null ? emptyLeg.spacesAvailable : null

          if (this.spacesOnly) {
            this.price = String(emptyLeg.exclusiveCost / emptyLeg.spacesAvailable)
          } else if (Number.isInteger(emptyLeg.exclusiveCost)) {
            this.price = `${emptyLeg.exclusiveCost}`
          } else {
            this.price = `${emptyLeg.exclusiveCost.toFixed(2)}`
          }

          const tailNumber = this.fleet.find(item => item.aircraftId === emptyLeg.aircraftId).tailNumber
          await this.selectAircraft(tailNumber)

          if (emptyLeg.additionalModelType) {
            this.displayModelOrTypeName = emptyLeg.additionalModelType
          }
        } catch (e) {
          console.log(e)
        }

        this.loading = false
        this.syncRadioCheckedState()
      },
      async uploadPhotos () {
        const uploadedPhotos = []
        await Promise.all(
          this.photos
            .filter(photo => photo.file)
            .map(async (photo) => {
              const formData = new FormData()
              formData.append('Name', photo.name)
              formData.append('File', photo.file)
              formData.append('Order', photo.order)

              const { data } = await aircraftsAPI.aircraftUploadPhoto(formData)
              uploadedPhotos.push({ ...data, order: photo.order })
            }),
        )

        return uploadedPhotos.sort((a, b) => a.order - b.order)
      },
      prepareRequestPayload (uploadedPhotos) {
        const [startDate, endDate] = this.dateRange
        const price = Number(this.price)
        const spacesAvailable = this.spacesAvailable ? Number(this.spacesAvailable) : null

        const aircraftSpaces = Number(this.spaces) > 1
          ? Number(this.spaces)
          : 1

        const aircraft = {
          ...(this.selectedAircraftIsType
            ? { typeId: this.aircraftModelOrTypeId }
            : { modelId: this.aircraftModelOrTypeId }),
          maxPassengers: this.maxPax ? Number(this.maxPax) : 0,
          sellAsCharterSeat: this.spacesOnly || aircraftSpaces > 1,
          spaces: this.spacesOnly ? Number(spacesAvailable || 0) : aircraftSpaces,
          argusSafetyRating: this.argusSafetyRating || null,
          wyvernSafetyRating: this.wyvernSafetyRating || null,
          wiFiTypeId: this.wiFiTypeId || null,
          images: uploadedPhotos,
          homebaseId: this.selectedDeparture.id,
        }

        const emptyLeg = {
          departureAirportId: this.selectedDeparture.id,
          arrivalAirportId: this.selectedLanding.id,
          exclusiveCost: this.spacesOnly ? price * Number(spacesAvailable || 0) : price,
          additionalModelType: this.aircraftModelOrTypeName !== this.displayModelOrTypeName ? this.displayModelOrTypeName : null,
          displayDeparture: this.displayDeparture !== '' ? this.displayDeparture : null,
          displayArrival: this.displayArrival !== '' ? this.displayArrival : null,
          displayDepartureCode: this.displayDepartureCode !== '' ? this.displayDepartureCode : null,
          displayArrivalCode: this.displayArrivalCode !== '' ? this.displayArrivalCode : null,
          departureReroutingRadius: Number(this.departureReroutingRadius) || 0,
          arrivalReroutingRadius: Number(this.arrivalReroutingRadius) || 0,
          sendRouteAlert: this.sendRouteAlert,
        }

        if (this.selectedAircraft?.aircraftId) {
          aircraft.aircraftId = this.selectedAircraft.aircraftId
          aircraft.tailNumber = this.selectedAircraft.tailNumber
          emptyLeg.aircraftId = this.selectedAircraft.aircraftId
        }

        if (this.spacesOnly) {
          emptyLeg.spacesAvailable = Number(spacesAvailable || 0)
        }

        if (this.emptyLegId) {
          emptyLeg.emptyLegId = this.emptyLegId
        }

        return {
          startDate: startDate.format('YYYY-MM-DD'),
          endDate: endDate.format('YYYY-MM-DD'),
          aircraft: aircraft,
          emptyLeg: emptyLeg,
        }
      },
      async submitHandler () {
        if (!this.isReadyToSubmit()) {
          console.log('Invalid fields.')
          this.isNotReadyToSubmit = true

          return false
        }

        this.isNotReadyToSubmit = false
        this.loading = true

        try {
          if (this.removedPhotoIds.length) {
            await this.removeEditedPhotos()
          }

          const uploadedPhotos = await this.uploadPhotos()
          const payload = this.prepareRequestPayload(uploadedPhotos)

          await aircraftsAPI.addCustomEmptyLegsAndSpaces(payload)
          this.$router.push('/admin/custom-empty-legs-and-spaces')
        } catch (e) {
          console.log(e)
        }

        this.loading = false
      },
    },
    components: {
      SvgIcon,
      Spinner,
    },
  }
</script>
